module.exports = __webpack_public_path__ + "static/img/service-top.ec2b67a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zmr-images/service-top.png
// module id = kr4p
// module chunks = 2